import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: 'Inter';
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Inter';
`;

export const ModalBody = styled.div`
  margin-bottom: 20px;
  font-family: 'Inter';
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  font-family: 'Inter';
  button:first-child {
    font-weight: 400;
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: 15px;
  font-family: 'Inter';
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
  font-family: 'Inter';
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter';
  &:focus {
    outline: none;
    border-color: #0066cc;
  }
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`; 